/**
 * Global Constants for Pinpoint Education Frontend
 * Mirrors backend/constants.py
 */

export const Programs = {
    ISEE: 'isee',
    SAT: 'sat',
    VOCAB_MASTERY: 'vocab-mastery',
    ALL: ['isee', 'sat', 'vocab-mastery']
};

export const QuestionTypes = {
    SYNONYM: "synonym",
    SINGLE_WORD_COMPLETION: "single_word_completion",
    PAIRED_WORD_COMPLETION: "paired_word_completion",
    READING_COMPREHENSION: "reading_comprehension",
    SENTENCE_CLUES: "clues",
    MATH: "math"
};
